import React from "react";
import "./HowItWorks.css";
import { FaPhone, FaHeadset, FaFileInvoiceDollar, FaHandshake } from "react-icons/fa";
import { useTranslation } from "./hooks/useTranslation";

const HowItWorks = () => {
  const { t } = useTranslation();

  const steps = [
    {
      icon: <FaPhone />,
      title: t.step1Title,
      time: t.step1Time,
      description: [t.step1FillingForm, t.step1WebChat, t.step1Email, t.step1Call],
    },
    {
      icon: <FaHeadset />,
      title: t.step2Title,
      time: t.step2Time,
      description: [t.step2Discuss, t.step2FreeAdvice, t.step2Support],
    },
    {
      icon: <FaFileInvoiceDollar />,
      title: t.step3Title,
      time: "24 Hours", // Static or from translation
      description: [t.step3Discuss, t.step3Finalise, t.step3Pay],
    },
    {
      icon: <FaHandshake />,
      title: t.step4Title,
      time: "Instant",
      description: [t.step4FillingForm, t.step4Satisfaction],
    },
  ];

  return (
    <section className="how-it-works">
      <div className="container">
        <header className="how-it-works-header">
          <h2 className="animate-fadeIn">{t.howItWorksTitle || "How It Works"}</h2>
        </header>
        
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step-card animate-fadeIn">
              <div className="step-icon-wrapper">
                {step.icon}
              </div>
              <span className="step-number">Step 0{index + 1}</span>
              <h3>{step.title}</h3>
              {step.time && <span className="step-time">{step.time}</span>}
              <ul className="step-list">
                {step.description.map((desc, idx) => (
                  <li key={idx}>{desc}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
